import { normalize, schema } from 'normalizr';

const profile_group = {
  normalize(data) {
    const profileSchema = new schema.Entity('profiles');

    const profileGroupSchema = new schema.Entity('profileGroup', {
      profiles: [profileSchema]

    });
    return normalize(data, profileGroupSchema);
  }
}

export default profile_group;